import Cart from './Cart';

const CartSidebar = () => {
  return <Cart />;
};

export default CartSidebar;
